import FamilyDataStoreSlice from '../slices/data/FamilyDataStoreSlice'
import FamilyDataStoreSelectors from '../selectors/data/Families'
import StoreFamily from '../models/Family'
import useDataStoreItemsFetchedOnce from './helpers/useDataStoreItemsFetchedOnce'
import usePermission from './usePermission'

const JSONStoreFamilyToStoreFamily = JSONStoreFamily => StoreFamily.FromJSON(JSONStoreFamily)

/**
 * Returns requested-/all family(s) from state.data.families.
 * @param familyIds {string | string[] | null}: id of requested families. If null, all families are requested.
 * @param asMap {boolean}: when multiple families are requested, return families as an object mapping families by their id.
 * @param fetchEnabled {boolean}: when false, only reads from the store (no list API call).
 * @returns {StoreFamily | StoreFamily[]}
 */
const useNormalizedFamilies = (familyIds = null, asMap = false, fetchEnabled = undefined) => {
  const canListFamilies = usePermission('family', 'find')
  const shouldFetch = fetchEnabled ?? canListFamilies

  return useDataStoreItemsFetchedOnce(
    familyIds,
    FamilyDataStoreSelectors.families,
    FamilyDataStoreSlice.actions.fetch,
    JSONStoreFamilyToStoreFamily,
    asMap,
    shouldFetch
  )
}

export default useNormalizedFamilies
